module.exports = __webpack_public_path__ + "img/家国-恩义好台.d52985bc.png";